import { useObservable, usePageTitle } from '@lib/common';
import { propertyQuery, sessionQuery } from '@lib/state';
import React from 'react';
import { DownloadInvoiceSummary, UnbilledReservationsReport } from '../components';
import { Container } from '@material-ui/core';

export function DownloadableReportsPage() {
  usePageTitle('Financial Reports');
  const customerId = useObservable(propertyQuery.activeProperty)?.customerId;
  const propertyId = useObservable(sessionQuery.propertyId, 'async');

  return (
    <Container maxWidth="xl">
      <DownloadInvoiceSummary customerId={customerId ?? ''} />
      <UnbilledReservationsReport customerId={customerId ?? ''} propertyId={propertyId ?? ''} />
    </Container>
  );
}
